import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { TenantsGridViewModel } from '@program-suite/data-common/program';

@Injectable({
  providedIn: 'root',
})
export class WholesalerSettingsService {
  http = inject(HttpClient);

  /**
   * Get pending requests
   * @param params - Criteria for filtering pending requests
   * @returns 200 - OK(PendingRequestGridViewModel)
   * @throws Error if the request fails
   */
  async getWholesalers(params: any): Promise<TenantsGridViewModel> {
    try {
      return await firstValueFrom(
        this.http.get<TenantsGridViewModel>('tenant', { params, responseType: 'json', })
      );
    } catch (error) {
      throw new Error('Failed to fetch wholesalers. Please try again.');
    }
  }
}